import {useMemo} from 'react';
import savedSearchesSingleton from '@netx/core-search/collections/singleton/savedSearch';
import useBackboneCollection from '@netx/core-components/hooks/useBackboneCollection';
import {useConstCallback} from '@netx/core-components/hooks/useConstCallback';
import {
	useFilterItems,
	UseFilterItemsParams,
} from '@netx/core-components/hooks/useFilterItems';
import {SharedResourceMode} from '@netx/core-share/constants';
import type {SharedResource} from '@netx/core-share/types';
import {filterSharedResourcesByMode} from '@netx/core-share/utils';

export type UseSavedSearchesParams = {
	filterMode?: SharedResourceMode;
};

export const useSavedSearches = ({filterMode}: UseSavedSearchesParams = {}) => {
	const savedSearches = useBackboneCollection(
		savedSearchesSingleton.allSavedSearches,
		false,
	);

	const {filteredItems, ...filterRest} = useFilterItems({
		filterFn: useConstCallback<
			UseFilterItemsParams<SharedResource>['filterFn']
		>((filter, items) =>
			items.filter((item) => item.title.toLowerCase().includes(filter)),
		),
		items: useMemo(
			() => filterSharedResourcesByMode(savedSearches, filterMode),
			[savedSearches, filterMode],
		),
	});

	return {
		...filterRest,
		savedSearches: filteredItems,
	};
};

export default useSavedSearches;
